import React, { useState } from "react";
import Layout from "../layout/Layout";
import {
	Button,
	Col,
	Divider,
	Flex,
	Form,
	Input,
	InputNumber,
	Modal,
	notification,
	Radio,
	Row,
	Select,
	Typography,
	DatePicker,
	Checkbox,
	Popconfirm,
	Statistic,
} from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import ClientModal2 from "../client/ClientModal2";
import dayjs from "dayjs";
import {
	jobPourOptions,
	jobTypeOptions,
	slumpOptions,
} from "../../constants/Job";
import { cityList } from "../utils/CityList";
import AddressGeolocation2 from "../map/AddressGeolocation2";
import ForemanModal from "../foreman/ForemanModal";
import { paymentTypeOptions } from "../../constants/Customer";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import ReadLoad2 from "./ReadLoad2";
import JobCheckIn from "./JobCheckIn";
import AddProjectExempt from "./AddProjectExempt";
import AddProjectBond from "./AddProjectBond";
import { useRef } from "react";

const { Title, Text } = Typography;

const jobStatusOptions = [
	{
		value: "Trouble",
		label: "Trouble",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "ok",
		label: "Poured",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "Confirm",
		label: "A/R Confirmed",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "Operations done (AR)",
		label: "Operations done (AR)",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "Scheduled",
		label: "Scheduled",
		disabled: !(
			localStorage.getItem("email") === "dm@57concrete.com" ||
			localStorage.getItem("email") === "rs@57concrete.com" ||
			localStorage.getItem("email") === "jp@57concrete.com" ||
			localStorage.getItem("email") === "vm@57concrete.com" ||
			localStorage.getItem("email") === "ec@57concrete.com" ||
			localStorage.getItem("email") === "pc@57concrete.com" ||
			localStorage.getItem("email") === "jc@57concrete.com" ||
			localStorage.getItem("email") === "gg@57xgroup.com" ||
			localStorage.getItem("email") === "eliud@gmail.com"
		),
	},
	{
		value: "Inactive",
		label: "Inactive",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "Company cancellation",
		label: "Company cancellation",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{ value: "Customer cancellation", label: "Customer cancellation" },
	{
		value: "Date moved",
		label: "Date moved",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{
		value: "Active",
		label: "Pouring",
		disabled:
			localStorage.getItem("email") === "jac@57concrete.com" ||
			localStorage.getItem("email") === "ds@57concrete.com" ||
			localStorage.getItem("email") === "ep@57concrete.com" ||
			localStorage.getItem("email") === "ev@57concrete.com" ||
			localStorage.getItem("email") === "jbr@57concrete.com",
	},
	{ value: "Ready to Load", label: "Ready to be scheduled" },
	{ value: "Quote", label: "Quote" },
	{ value: "Waiting Inspection", label: "Waiting Inspection" },
];

const qcTypes = [
	{ value: "Internal", label: "Internal" },
	{ value: "External", label: "External" },
];

const qcInternalTypes = [
	{ value: "Job Sampling", label: "Job Sampling" },
	{ value: "Plant", label: "Plant" },
];

const columnsJobStatus = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "status",
		key: "status",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columnsPsi = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "PSI",
		dataIndex: "psi",
		key: "psi",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];
const columnsUnitPrice = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "jobStatus",
		key: "jobStatus",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Unit Price",
		dataIndex: "unitPrice",
		key: "unitPrice",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columnsYards = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "jobStatus",
		key: "jobStatus",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Yards",
		dataIndex: "yards",
		key: "yards",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columnsScheduledDate = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Prev Date",
		dataIndex: "prevDate",
		key: "prevDatepsi",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "New  Date",
		dataIndex: "newDate",
		key: "newDate",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Comment",
		dataIndex: "comment",
		key: "comment",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columnsPlantChanged = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Prev Plant",
		dataIndex: "prevPlant",
		key: "prevPlant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Prev Unit Price",
		dataIndex: "prevUnitPrice",
		key: "prevUnitPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Next Plant",
		dataIndex: "nextPlant",
		key: "nextPlant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Next Unit Price",
		dataIndex: "nextUnitPrice",
		key: "nextUnitPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
];

const AUTHORIZED_EMAILS_SCHEDULED = [
	"jp@57concrete.com",
	"ec@57concrete.com",
	"eliud@gmail.com",
];

// const UNRESTRICTED_EMAILS_CONFIRM_YARDS = [
// 	"eliud@gmail.com",
// 	"ec@57concrete.com",
// ];

const Job2 = (props) => {
	const [loading, setLoading] = useState(true);
	const [loadingComponents, setLoadingComponents] = useState(true);
	const [loadingCustomer, setLoadingCustomer] = useState(true);
	const [loadingSeller, setLoadingSeller] = useState(true);
	const [loadingPsi, setLoadingPsi] = useState(true);
	const [loadingPlant, setLoadingPlant] = useState(true);
	const [loadingForeman, setLoadingForeman] = useState(true);
	const [dateMax, setDateMax] = useState(dayjs());
	const [minDateScheduledDate, setMinDateScheduledDate] = useState(dayjs());
	const [disabledDate, setDisabledDate] = useState(true);
	const [dateChanged, setDateChanged] = useState(false);
	const [isOver30, setIsOver30] = useState(false);
	const [checkInValues, setCheckInValues] = useState({});
	const [currentMeasurement, setCurrentMeasurement] = useState(false);
	const [checkInLatitude, setCheckInLatitude] = useState(undefined);
	const [checkInLongitude, setCheckInLongitude] = useState(undefined);
	const [jobStatusHistory, setJobStatusHistory] = useState([]);
	const [psiHistory, setPsiHistory] = useState([]);
	const [unitPriceHistory, setUnitPriceHistory] = useState([]);
	const [yardsHistory, setYardsHistory] = useState([]);
	const [scheduledDateHistory, setScheduledDateHistory] = useState([]);
	const [jobStatusCurrent, setJobStatusCurrent] = useState("");
	const [jobStatusPrev, setJobStatusPrev] = useState("");
	const [psiPrev, setPsiPrev] = useState("");
	const [unitPricePrev, setUnitPricePrev] = useState(0);
	const [yardsPrev, setYardsPrev] = useState(0);
	const [loads, setLoads] = useState("");
	const [loadYD3, setLoadYD3] = useState(0);
	const [addressChanged, setAddressChanged] = useState(false);
	const [sellers, setSellers] = useState([]);
	const [sellerPhone, setSellerPhone] = useState("");
	const [customers, setCustomers] = useState([]);
	const [psi, setPsi] = useState([]);
	const [plants, setPlants] = useState([]);
	const [foremans, setForemans] = useState([]);
	const [initialValues, setInitialValues] = useState({});
	const [openNewCustomerModal, setOpenNewCustomerModal] = useState(false);
	const [openSearchAddressModal, setOpenSearchAddressModal] = useState(false);
	const [openNewForemanModal, setOpenNewForemanModal] = useState(false);
	const [openLoadsModal, setOpenLoadsModal] = useState(false);
	const [openCheckInModal, setOpenCheckInModal] = useState(false);
	const [openProjectExemptModal, setOpenProjectExemptModal] = useState(false);
	const [openProjectBondModal, setOpenProjectBondModal] = useState(false);
	const [minPrice, setMinPrice] = useState(0);
	const [form] = Form.useForm();
	const [franchise, setFranchise] = useState("57Concrete");
	const [approvedPrice, setApprovedPrice] = useState(false);
	const [qc, setQC] = useState(false);
	const [qcType, setQCType] = useState("Internal");
	const [isWasteJob, setIsWasteJob] = useState(false);
	const [projectList, setProjectList] = useState([]);
	const [scheduledDateChanged, setScheduledDateChanged] = useState(false);
	const [plantChangedHistory, setPlantChangedHistory] = useState([]);
	const [plantChanged, setPlantChanged] = useState(false);
	const [prevPlant, setPrevPlant] = useState(null);
	const [prevUnitPrice, setPrevUnitPrice] = useState(null);
	const currentUnitPrice = useRef(null);
	const messageUnitPrice = useRef(null);
	const [openModalUnitPrice, setOpenModalUnitPrice] = useState(false);
	const [onScheduled, setOnScheduled] = useState(false);
	const [openModalConfirmYards, setOpenModalConfirmYards] = useState(false);
	// const [pourDate, setPourDate] = useState(undefined);
	// const [pourYards, setPourYards] = useState(false);
	// const [pourYardsPersisted, setPourYardsPersisted] = useState(false);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
			duration: null,
			stack: { threshold: 3 },
		});
	};

	useEffect(() => {
		getLocation();
		checkJobFranchise();
	}, []);

	const getLocation = () => {
		if (navigator.geolocation) {
			// Success callback
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setCheckInLatitude(position.coords.latitude);
					setCheckInLongitude(position.coords.longitude);
				},
				// Error callback
				(error) => {
					setCheckInLatitude(undefined);
					setCheckInLongitude(undefined);
					openNotification("warning", "Warning", error.message);
				},
			);
		} else {
			setCheckInLatitude(undefined);
			setCheckInLongitude(undefined);
			openNotification(
				"warning",
				"Warning",
				"Geolocation is not supported by this browser.",
			);
		}
	};

	const checkJobFranchise = async () => {
		const url = api + "/job/check/franchise/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				setFranchise(data.payload);
				getAllSelectValues(data.payload);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getAllSelectValues = async (franchise) => {
		await Promise.all([
			getCustomers(franchise),
			getSellers(franchise),
			// getPsi(franchise),
			getPlants(franchise),
			getForemans(franchise),
		]).then(async (values) => {
			setLoadingComponents(false);
			await getJob(franchise);
			// await getJob(values[2]);
			await getLoadData();
			setLoading(false);
		});
	};

	const getLoadData = async () => {
		const url = api + "/load/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setLoads(data);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getJob = async (franchise) => {
		const url = api + "/job/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			// if(data.seller)
			// setSellers((prev) => [
			// 	...prev,
			// 	{
			// 		value: data.seller._id,
			// 		simpleLabel: data.seller.name,
			// 		label: (
			// 			<div style={{ display: "flex", justifyContent: "space-between" }}>
			// 				<span>{data.seller.name}</span>
			// 				<Tag
			// 					color={
			// 						(data.seller.franchise || "57Concrete") === "57Concrete"
			// 							? "blue"
			// 							: "green"
			// 					}
			// 				>
			// 					{data.seller.franchise || "57Concrete"}
			// 				</Tag>
			// 			</div>
			// 		),
			// 	},
			// ]);

			const psis = await getPsi(franchise, data.plant);

			const projects = await getProjects(data.customer._id);

			setProjectList(projects);

			setInitialValues({
				approved: data.approved || false,
				prefix: "+1",
				number: data.number,
				customer: `${data.customer._id},${data.customer.paymentType},${data.customer.paymentTerm}`,
				paymentType: data.customer.paymentType,
				paymentTerm: data.customer.paymentTerm,
				seller: data.seller._id,
				jobStatus: data.jobStatus,
				jobType: data.jobType,
				jobPoor: data.jobPoor,
				name: data.name,
				jobDescription: data.jobDescription,
				psi:
					psis.length !== 0
						? psis.find((i) => i.value.split(",")[0] === data.psiId) ===
							undefined
							? psis.find((i) => i.label === data.psi).value
							: psis.find((i) => i.value.split(",")[0] === data.psiId).value
						: undefined,
				psiId:
					psis.length !== 0
						? psis.find((i) => i.value.split(",")[0] === data.psiId) ===
							undefined
							? psis.find((i) => i.label === data.psi).value.split(",")[0]
							: psis
									.find((i) => i.value.split(",")[0] === data.psiId)
									.value.split(",")[0]
						: undefined,
				psiName:
					psis.length !== 0
						? psis.find((i) => i.value.split(",")[0] === data.psiId) ===
							undefined
							? psis.find((i) => i.label === data.psi).label
							: psis.find((i) => i.value.split(",")[0] === data.psiId).label
						: undefined,
				plant: data.plant,
				shipAddress: data.shipAddress,
				customerShipAddress: data.customerShipAddress || "",
				shipCity: data.shipCity.toLowerCase(),
				city: data.shipCity,
				latitude: data.latitude,
				longitude: data.longitude,
				destinationTime: data.destinationTime,
				distance: data.distance,
				foremanItem: `${data.foreman},${data.jobForeman},${data.foremanPhone}`,
				foreman: data.foreman,
				jobForeman: data.jobForeman,
				foremanPhone: data.foremanPhone
					? data.foremanPhone.slice(2)
					: undefined,
				supervisorName: data.supervisorName || undefined,
				supervisorPhone: data.supervisorPhone
					? data.supervisorPhone.slice(2)
					: undefined,
				projectManager: data.projectManager || undefined,
				pmPhone: data.pmPhone ? data.pmPhone.slice(2) : undefined,
				apContact: data.apContact || undefined,
				apPhone: data.apPhone ? data.apPhone.slice(2) : undefined,
				customer1: data.customer1 || undefined,
				customer1Phone: data.customer1Phone
					? data.customer1Phone.slice(2)
					: undefined,
				customer2: data.customer2 || undefined,
				customer2Phone: data.customer2Phone
					? data.customer2Phone.slice(2)
					: undefined,
				taxExemptJob: data.taxExemptJob,
				targetYD3: data.targetYD3,
				deliveryRate: data.deliveryRate || undefined,
				balance: data.balance || undefined,
				jobDuration: data.jobDuration || undefined,
				scheduledDate: dayjs(new Date(data.scheduledDate)),
				inspectionTimeStamp: dayjs(new Date(data.inspectionTimeStamp)),
				logisticDate: data.logisticDate
					? dayjs(new Date(data.logisticDate))
					: undefined,
				fiberQuantity: data.fiberQuantity || undefined,
				unitPrice: data.unitPrice,
				taxPrice: data.unitPrice * 1.0825,
				paid: data.paid || false,
				fuelSurchargeGlobal: data.fuelSurchargeGlobal || false,
				fuelSurcharge: data.fuelSurcharge || 0,
				timeSurchargeGlobal: data.timeSurchargeGlobal || false,
				timeSurcharge: data.timeSurcharge || 0,
				lightSurchargeGlobal: data.lightSurchargeGlobal || false,
				lightSurcharge: data.lightSurcharge || 0,
				iceSurchargeGlobal: data.iceSurchargeGlobal || false,
				iceSurcharge: data.iceSurcharge || 0,
				readyMixTruckRentalServiceGlobal:
					data.readyMixTruckRentalServiceGlobal || false,
				readyMixTruckRentalService: data.readyMixTruckRentalService || 0,
				readyMixDriverGlobal: data.readyMixDriverGlobal || false,
				readyMixDriver: data.readyMixDriver || 0,
				plantStandByGlobal: data.plantStandByGlobal || false,
				plantStandBy: data.plantStandBy || 0,
				environmentalChargePerLoadGlobal:
					data.environmentalChargePerLoadGlobal || false,
				environmentalChargePerLoad: data.environmentalChargePerLoad || 0,
				shippingGlobal: data.shippingGlobal || false,
				deliveryFee: data.deliveryFee,
				comments: data.comments,
				slump: data.slump,
				qualityControl: data.qualityControl || false,
				qcType: data.qcType || "Internal",
				qcName: data.qcName,
				// qcTechnical: data.qcTechnical,
				qcInternalType: data.qcInternalType,
				estimatedTime: data.estimatedTime || 60,
				hotShot: data.hotShot || false,
				approvedPrice: data.approvedPrice || false,
				factoredInvoice: data.factoredInvoice || false,
				isWasteJob: data.isWasteJob || false,
				commentWaste: data.commentWaste || "",
				project: data.project,
				customerPONumber: data.customerPONumber || "",
				// psiId: psi.find((i) => i.name === data.psi)
			});
			setIsWasteJob(data.isWasteJob || false);
			setQC(data.qualityControl || false);
			setQCType(data.qcType || "Internal");
			setApprovedPrice(data.approvedPrice || false);

			let sumYards = 0;
			if (data.targetYD3) {
				sumYards += data.targetYD3;
			}
			if (data.balance) {
				sumYards += data.balance;
			}

			if (sumYards < 50) {
				setIsOver30(false);
			} else if (sumYards >= 50) {
				setIsOver30(true);
				// setCurrentMeasurement(data.measurement || false);

				// setCheckInValues({
				// 	measurement: data.measurement || false,
				// 	measurementYards: data.measurementYards || undefined,
				// 	readyForTruck: data.readyForTruck || false,
				// 	readyForTruckComments: data.readyForTruckComments || undefined,
				// 	lightTowerPositions: data.lightTowerPositions || false,
				// 	lightTowerPositionsNumberTag:
				// 		data.lightTowerPositionsNumberTag || undefined,
				// 	lightTowerPositionsBrand: data.lightTowerPositionsBrand || undefined,
				// 	pour: data.pour || false,
				// 	jobStatus: data.jobStatus,
				// });
			}
			setCurrentMeasurement(data.measurement || false);

			setCheckInValues({
				measurement: data.measurement || false,
				measurementYards: data.measurementYards || undefined,
				readyForTruck: data.readyForTruck || false,
				readyForTruckComments: data.readyForTruckComments || undefined,
				lightTowerPositions: data.lightTowerPositions || false,
				lightTowerPositionsNumberTag:
					data.lightTowerPositionsNumberTag || undefined,
				lightTowerPositionsBrand: data.lightTowerPositionsBrand || undefined,
				pour: data.pour || false,
				jobStatus: data.jobStatus,
			});

			setMinDateScheduledDate(
				data.hotShot ? dayjs(new Date()) : dayjs(new Date()).add(36, "hour"),
			);
			setDateMax(dayjs(new Date(data.scheduledDate)));

			getDatePermissions(data.jobStatus);
			setSellerPhone(data.seller ? data.seller.phone : "");

			setJobStatusPrev(data.jobStatus);
			setPsiPrev(data.psiId);
			setUnitPricePrev(data.unitPrice);
			setYardsPrev(data.targetYD3);
			setJobStatusCurrent(data.jobStatus);
			setLoadYD3(data.loadYD3);

			const jobHistory = [];

			data.jobStatusHistory.map((item, index) => {
				jobHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					user: item.user.name,
					status: changeStatusLabels(item.jobStatus),
				});
			});

			setJobStatusHistory(jobHistory);

			const psiHistory = [];

			data.psiHistory.map((item, index) => {
				psiHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					user: item.user.name,
					psi: item.psi.psi,
				});
			});

			setPsiHistory(psiHistory);
			const unitPriceHistory = [];

			data.unitPriceHistory.map((item, index) => {
				unitPriceHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					user: item.user.name,
					unitPrice: item.unitPrice,
					jobStatus: changeStatusLabels(item.jobStatus),
				});
			});

			setUnitPriceHistory(unitPriceHistory);

			const yardsHistory = [];

			data.yardsHistory.map((item, index) => {
				yardsHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					user: item.user.name,
					yards: item.yards,
					jobStatus: changeStatusLabels(item.jobStatus),
				});
			});

			setYardsHistory(yardsHistory);

			const scheduledDateHistory = [];

			data.scheduledDateHistory.map((item, index) => {
				scheduledDateHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					prevDate: dayjs(item.prevDate).format("MM/DD/YYYY hh:mm:ss A"),
					newDate: dayjs(item.newDate).format("MM/DD/YYYY hh:mm:ss A"),
					user: item.user.name,
					comment: item.comment,
				});
			});

			setScheduledDateHistory(scheduledDateHistory);

			const plantChangedHistory = [];

			data.plantChangedHistory.map((item, index) => {
				plantChangedHistory.push({
					key: index,
					date: dayjs(item.createdAt).format("MM/DD/YYYY hh:mm:ss A"),
					prevPlant: item.prevPlant.name,
					nextPlant: item.nextPlant.name,
					prevUnitPrice: item.prevUnitPrice,
					nextUnitPrice: item.nextUnitPrice,
					user: item.user.name,
				});
			});

			setPlantChangedHistory(plantChangedHistory);

			setPrevPlant(data.plant);
			setPrevUnitPrice(data.unitPrice);
			currentUnitPrice.current = data.unitPrice;
			setOnScheduled(data.onScheduled || false);

			// setPourDate(data.pourDate ? dayjs(data.pourDate) : undefined);
			// setPourYards(data.pourYards || false);
			// setPourYardsPersisted(data.pourYards || false);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	const getProjects = async (customerId) => {
		const url = api + "/projectcustomer/" + customerId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const list = [];
			data.map((item) => {
				list.push({ value: item._id, label: item.name });
			});
			return list;
		} catch (err) {
			console.error(err);
			return [];
		}
	};

	const changeStatusLabels = (jobStatus) => {
		if (jobStatus === "ok") {
			return "Poured";
		} else if (jobStatus === "Confirm") {
			return "A/R Confirmed";
		} else if (jobStatus === "Active") {
			return "Pouring";
		} else if (jobStatus === "Ready to Load") {
			return "Ready to be scheduled";
		} else {
			return jobStatus;
		}
	};

	const getDatePermissions = (status) => {
		if (
			localStorage.getItem("email") === "mv@57concrete.com" ||
			localStorage.getItem("email") === "bpa@57concrete.com" ||
			localStorage.getItem("email") === "al@57concrete.com" ||
			localStorage.getItem("email") === "vm@57concrete.com" ||
			localStorage.getItem("email") === "ecavazos@57concrete.com" ||
			localStorage.getItem("email") === "ga@57concrete.com" ||
			localStorage.getItem("email") === "jp@57concrete.com" ||
			localStorage.getItem("email") === "eliud@gmail.com"
		) {
			setDisabledDate(false);
		} else {
			if (
				status === "New Order" ||
				status === "Wait Inspection" ||
				status === "Waiting Inspection" ||
				(localStorage.getItem("role") === "Seller" && status === "Quote")
			) {
				setDisabledDate(false);
			} else {
				setDisabledDate(true);
			}
		}
	};

	// const canEditPourYards = () => {
	// 	const email = localStorage.getItem("email");

	// 	if (UNRESTRICTED_EMAILS_CONFIRM_YARDS.includes(email)) {
	// 		return true;
	// 	}

	// 	if (pourYardsPersisted === true) {
	// 		return false;
	// 	}

	// 	if (jobStatusCurrent === "Active") {
	// 		return true;
	// 	}

	// 	const now = dayjs();

	// 	if (pourDate) {
	// 		return now.isBefore(dayjs(pourDate).add(2, "hour"));
	// 	}

	// 	const scheduled = dayjs(dateMax);
	// 	return now.isBefore(scheduled) && scheduled.diff(now, "hour", true) < 2;
	// };

	const getCustomers = async (franchise) => {
		const url = api + `/customer/franchise/available/${franchise}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						label: `${item.customerNumber} ${item.name}`,
						value: `${item._id},${item.paymentType},${item.paymentTerm}`,
					});
				});
				setCustomers(list);
				setLoadingCustomer(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getSellers = async (franchise) => {
		const url =
			api +
			`/user/list/${
				franchise === "57Concrete" || franchise === "Valley Wide"
					? "57Concrete"
					: franchise
			}/Seller`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						label: item.name,
						value: item._id,
					});
				});
				setSellers(list);
				setLoadingSeller(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getPsi = async (franchise, plant) => {
		const url = api + `/psi/list/${franchise}/${plant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];

			data.map((item) => {
				list.push({
					value: `${item._id},${item.cogsPrice},${item.minPrice || 0}`,
					label: item.psi,
					disabled: !item.active,
				});
			});
			setPsi(list);
			setLoadingPsi(false);
			return list;
		} catch (err) {
			console.error(err.message);
			return [];
		}
	};

	const getPlants = async (franchise) => {
		const url =
			api +
			`/plant/list/${
				franchise === "57Concrete" || franchise === "Valley Wide"
					? "57Concrete"
					: franchise
			}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload
					.filter((i) => i.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setPlants(list);
				setLoadingPlant(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getForemans = async (franchise) => {
		const url = api + `/foreman/list/${franchise}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const optionsAux = [];
			data.forEach((foreman) => {
				let value = `${foreman._id},${foreman.firstName} ${foreman.lastName},${foreman.phone}`;
				let aux = `${foreman.firstName} ${foreman.lastName}`;
				let label = aux.toUpperCase();
				let obj = {
					value: value,
					label: label,
				};
				if (foreman.active) optionsAux.push(obj);
			});
			setForemans(optionsAux);
			setLoadingForeman(false);
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const handleNewCustomerOpen = () => {
		setOpenNewCustomerModal(true);
	};

	const handleNewCustomerCancel = () => {
		setOpenNewCustomerModal(false);
	};

	const onNewClientNew = async (newClient) => {
		setLoadingCustomer(true);
		await getCustomers();
		form.setFieldValue("customer", newClient);
		const values = newClient.split(",");
		form.setFieldValue("paymentType", values[1]);
		form.setFieldValue(
			"paymentTerm",
			values[2] === "undefined" ? "" : values[2],
		);
		setOpenNewCustomerModal(false);
	};

	const RenderNewCustomerModal = () => {
		return (
			<Modal
				title="New Customer"
				open={openNewCustomerModal}
				onCancel={handleNewCustomerCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
			>
				<ClientModal2 pcb={onNewClientNew} />
			</Modal>
		);
	};

	const onChangeJobStatus = (selectedJobStatus) => {
		if (selectedJobStatus) {
			if (
				selectedJobStatus.value === "Operations done (AR)" &&
				form.getFieldValue("approvedPrice") === false
			) {
				form.setFieldValue("jobStatus", jobStatusPrev);
				openNotification("info", "Info", "Approved Price must be checked");
				return;
			}

			if (
				selectedJobStatus.value === "Operations done (AR)" ||
				selectedJobStatus.value === "Scheduled"
			) {
				setOnScheduled(true);
			} else {
				setOnScheduled(false);
			}

			// if (selectedJobStatus.value === "ok") {
			// 	setPourDate(dayjs());
			// } else {
			// 	setPourDate(undefined);
			// }

			setJobStatusCurrent(selectedJobStatus.value);
			form.setFieldValue("jobStatus", selectedJobStatus.value);
			form.setFieldValue("approved", true);
			setCheckInValues((prev) => ({
				...prev,
				jobStatus: selectedJobStatus.value,
			}));
			if (selectedJobStatus.value === "Ready to Load") {
				form.setFieldValue("readyToBeScheduledDate", dayjs().toDate());
				if (
					!(
						localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "ec@57concrete.com"
					)
				) {
					if (!checkInValues.measurement) {
						handleCheckInOpen();
					}
				} else {
					handleCheckInOpen();
				}
			}
		}
	};

	const onChangePsi = (selectedPsi) => {
		if (selectedPsi) {
			let values = selectedPsi.value.split(",");
			form.setFieldsValue({
				psiPrice: undefined,
				// psiPrice: values[1],
				unitPrice: undefined,
				taxPrice: undefined,
				// unitPrice: values[1],
				// taxPrice: values[1] * 1.0825,
				psiName: selectedPsi.label,
				psi: selectedPsi.value,
				psiId: values[0],
			});
			setMinPrice(Number(values[2]));

			// messageUnitPrice.current = `Previous Unit Price: ${currentUnitPrice.current}. \nNew Unit Price Value: ${values[1]}. \nPlease check the new price and approve it to continue.`;
			messageUnitPrice.current = `Previous Unit Price: ${currentUnitPrice.current}. \nPlease check the new price and approve it to continue.`;

			setOpenModalUnitPrice(true);

			// openNotification(
			// 	"warning",
			// 	"Unit Price has changed!",
			// 	`Previous Unit Price: ${form.getFieldValue(
			// 		"unitPrice",
			// 	)}. New Unit Price Value: ${values[1]}`,
			// );
		}
	};

	const onChangeCity = (selectedCity) => {
		if (selectedCity) {
			form.setFieldValue("shipCity", selectedCity.value);
			form.setFieldValue("city", selectedCity.label);
		}
	};

	const handleSearchAddressCancel = () => {
		setOpenSearchAddressModal(false);
	};

	const handleSearchAddressOpen = () => {
		setOpenSearchAddressModal(true);
	};

	const handleCallback = (childData) => {
		form.setFieldsValue({
			shipAddress: childData.address,
			destinationTime: childData.duration,
			distance: childData.distance,
			latitude: childData.destLat,
			longitude: childData.destLng,
			shipCity: childData.locality
				? childData.locality.toLowerCase()
				: undefined,
		});
		handleSearchAddressCancel();
		setAddressChanged(true);

		let cityFound = cityList.find((city) => city.label === childData.locality);
		if (typeof cityFound !== "undefined") {
			form.setFieldValue("city", childData.locality);
		} else {
			form.setFieldValue("city", undefined);
			form.setFieldValue("shipCity", undefined);
			openNotification(
				"warning",
				"Warning",
				`The city ${childData.locality} is not defined in list, please select it from city options to save it.`,
			);
		}
	};

	const RenderSearchAddressModal = () => {
		return (
			<Modal
				title="Address"
				open={openSearchAddressModal}
				onCancel={handleSearchAddressCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
			>
				<AddressGeolocation2
					search={true}
					parentCallback={handleCallback}
					single={false}
					plant={form.getFieldValue("plant")}
					currentLocation={false}
				/>
			</Modal>
		);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	const onChangeForeman = (selectedForeman) => {
		if (selectedForeman) {
			let option = selectedForeman.split(",");
			let foremanID = option[0];
			let foremanName = option[1];
			let foremanPhone = option[2];
			form.setFieldsValue({
				foremanPhone: foremanPhone.slice(2),
				jobForeman: foremanName,
				foreman: foremanID,
			});
		}
	};

	const handleNewForemanCancel = () => {
		setOpenNewForemanModal(false);
	};

	const handleNewForemanOpen = () => {
		setOpenNewForemanModal(true);
	};

	const onNewFormanNew = async (newForeman) => {
		setLoadingForeman(true);
		await getForemans();
		let selected = `${newForeman.foreman},${
			newForeman.firstName + " " + newForeman.lastName
		},${newForeman.phone}`;
		form.setFieldsValue({
			jobForeman: newForeman.firstName + " " + newForeman.lastName,
			foremanPhone: newForeman.phone.slice(2),
			foreman: newForeman.foreman,
			foremanItem: selected,
		});
		handleNewForemanCancel();
	};

	const RenderNewForemanModal = () => {
		return (
			<Modal
				title="New Foreman"
				open={openNewForemanModal}
				onCancel={handleNewForemanCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
			>
				<ForemanModal parentCallback={onNewFormanNew} />
			</Modal>
		);
	};

	const RenderShowLoadsModal = () => {
		return (
			<Modal
				title="Loads"
				open={openLoadsModal}
				onCancel={handleShowLoadsCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={1000}
			>
				<ReadLoad2
					loads={loads}
					jobID={form.getFieldValue("number")}
					loadTotal={loadYD3}
				/>
			</Modal>
		);
	};

	const RenderCheckInModal = () => {
		return (
			<Modal
				title="Job Check In"
				open={openCheckInModal}
				onCancel={handleCheckInCancel}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={600}
			>
				<JobCheckIn
					values={checkInValues}
					setCheckInValues={setCheckInValues}
					handleCheckInCancel={handleCheckInCancel}
				/>
			</Modal>
		);
	};

	const RenderShowProjectExemptModal = () => {
		return (
			<Modal
				title="Add Project Exempt Evidence"
				open={openProjectExemptModal}
				onCancel={handleProjectExemptOpen}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={500}
			>
				<AddProjectExempt
					jobId={props.match.params.id}
					pcb={handleProjectExemptOpen}
				/>
			</Modal>
		);
	};
	const RenderShowProjectBondModal = () => {
		return (
			<Modal
				title="Add Project Bond Evidence"
				open={openProjectBondModal}
				onCancel={handleProjectBondOpen}
				cancelButtonProps={{
					style: { display: "none" },
				}}
				okButtonProps={{
					style: { display: "none" },
				}}
				width={500}
			>
				<AddProjectBond
					jobId={props.match.params.id}
					pcb={handleProjectBondOpen}
				/>
			</Modal>
		);
	};

	const range = (start, end) => {
		const result = [];
		for (let i = start; i < end; i++) {
			result.push(i);
		}
		return result;
	};

	const onChangeDate = (value) => {
		setDateMax(value);
		setDateChanged(true);
		form.setFieldValue("scheduledDate", value);
		form.setFieldValue("logisticDate", undefined);
		setScheduledDateChanged(true);
		if (form.getFieldValue("jobStatus") !== "Quote") {
			form.setFieldValue("jobStatus", "Date Moved");
		}
	};

	const disabledDateTime = (date) => {
		const scheduledDateDay = dayjs(dateMax).day();
		const currentDateDay = dayjs(date).day();
		if (scheduledDateDay === currentDateDay) {
			const scheduledDateMinute = dayjs(dateMax).minute();
			const scheduledDateHour = dayjs(dateMax).hour() + 1;
			return {
				disabledMinutes: () => range(scheduledDateMinute, 60),
				disabledHours: () => range(scheduledDateHour, 24),
			};
		} else {
			return {
				disabledMinutes: () => [],
				disabledHours: () => [],
			};
		}
	};

	const onChangeUnitPrice = (value) => {
		// let value = e.target.value;
		if (value !== null || value !== undefined) {
			if (value >= 0 && value <= 2000) {
				form.setFieldValue("taxPrice", value * 1.0825);
			}
		} else {
			form.setFieldValue("taxPrice", 0);
		}
		currentUnitPrice.current = value;
	};

	const handleShowLoadsCancel = () => {
		setOpenLoadsModal(false);
	};

	const handleShowLoadsOpen = () => {
		setOpenLoadsModal(true);
	};

	const handleCheckInCancel = () => {
		setOpenCheckInModal(false);
	};

	const handleCheckInOpen = async () => {
		if (
			checkInValues.measurement === false &&
			isOver30 &&
			!(
				localStorage.getItem("email") === "eliud@gmail.com" ||
				localStorage.getItem("email") === "ec@57concrete.com"
			)
		) {
			const isInCoords = await checkSellerPosition(
				form.getFieldValue("latitude"),
				form.getFieldValue("longitude"),
			);
			if (isInCoords) {
				setOpenCheckInModal(true);
			} else {
				openNotification(
					"warning",
					"Warning",
					"You must be at job direction to make check in",
				);
			}
		} else {
			// if (isOver30) {
			setOpenCheckInModal(true);
			// }
		}
	};

	const handleProjectExemptOpen = async () => {
		setOpenProjectExemptModal((prev) => !prev);
	};
	const handleProjectBondOpen = async () => {
		setOpenProjectBondModal((prev) => !prev);
	};

	const deleteJob = async () => {
		setLoadingComponents(true);
		const url = api + "/job/" + props.match.params.id;
		const urlLoad = api + "/loadjob/" + props.match.params.id;
		const urlHistory = api + "/history";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		const bodyHistory = {
			date: new Date(),
			customer: form.getFieldValue("customer").split(",")[0],
			user: localStorage.getItem("userId"),
			type: "Job",
			yards: form.getFieldValue("targetYD3"),
			number: form.getFieldValue("number"),
		};

		const req1 = axios.delete(url);
		const req2 = axios.delete(urlLoad);
		const req3 = axios.post(urlHistory, bodyHistory);

		// llamada simultanea a los 2 borrados
		axios
			.all([req1, req2, req3])
			.then(
				axios.spread((...responses) => {
					const res1 = responses[0];
					const res2 = responses[1];
					const res3 = responses[2];
					setLoadingComponents(false);

					props.history.push("/dailyappointment");
				}),
			)
			.catch((errors) => {
				openNotification("error", "Error", "Cannot delete job");
				setLoadingComponents(false);
				console.error(errors.message);
				return null;
			});
	};

	const jobPhotos = () => {
		const url = "/jobphotos/" + props.match.params.id;
		props.history.push(url);
	};

	const showHistory = () => {
		const url = "/jobhistory/" + form.getFieldValue("number");
		props.history.push(url);
	};

	const showQuote = () => {
		const url = "/quotepdf/" + props.match.params.id;
		props.history.push(url);
	};

	const showInvoice = async () => {
		await updateJob("invoice");
		const url = "/jobtoinvoice/" + props.match.params.id;
		props.history.push(url);
	};

	const showEtickets = () => {
		const url = "/eticketsjob/" + props.match.params.id;
		props.history.push(url);
	};

	const showInvoiceEtickets = () => {
		const url = "/invoice/job/etickets/" + props.match.params.id;
		props.history.push(url);
	};

	const updateJob = async (fromButton) => {
		const values = form.getFieldsValue(true);

		if (
			values.unitPrice === 0 ||
			values.unitPrice === null ||
			values.unitPrice === undefined
		) {
			setLoadingComponents(false);
			openNotification("error", "Error", "Unit Price cannot be 0");
			return;
		}

		let updateValues = {
			approved: values.approved,
			customer: values.customer.split(",")[0],
			paymentType: values.paymentType,
			seller: values.seller,
			jobStatus: values.jobStatus,
			jobType: values.jobType,
			jobPoor: values.jobPoor,
			name: values.name || undefined,
			jobDescription: values.jobDescription || undefined,
			psi: values.psiName,
			psiId: values.psiId,
			plant: values.plant,
			shipAddress: values.shipAddress,
			customerShipAddress: values.customerShipAddress,
			shipCity: values.city,
			destinationTime: values.destinationTime,
			distance: values.distance,
			latitude: values.latitude,
			longitude: values.longitude,
			foreman: values.foreman,
			jobForeman: values.jobForeman,
			foremanPhone: "+1" + values.foremanPhone,
			supervisorName: values.supervisorName || undefined,
			supervisorPhone: values.supervisorPhone
				? "+1" + values.supervisorPhone
				: undefined,
			projectManager: values.projectManager || undefined,
			pmPhone: values.pmPhone ? "+1" + values.pmPhone : undefined,
			apContact: values.apContact || undefined,
			apPhone: values.apPhone ? "+1" + values.apPhone : undefined,
			customer1: values.customer1 || undefined,
			customer1Phone: values.customer1Phone
				? "+1" + values.customer1Phone
				: undefined,
			customer2: values.customer2 || undefined,
			customer2Phone: values.customer2Phone
				? "+1" + values.customer2Phone
				: undefined,
			taxExemptJob: values.taxExemptJob,
			targetYD3: values.targetYD3,
			deliveryRate: values.deliveryRate,
			// balance: values.balance,
			jobDuration: values.jobDuration,
			logisticDate: values.logisticDate
				? dayjs(values.logisticDate).toDate()
				: undefined,
			scheduledDate: dayjs(values.scheduledDate).toDate(),
			scheduledDateComment: values.scheduledDateComment || "",
			inspectionTimeStamp: dayjs(values.inspectionTimeStamp).toDate(),
			fiberQuantity: values.fiberQuantity || 0,
			unitPrice: values.unitPrice,
			paid: values.paid,
			fuelSurchargeGlobal: values.fuelSurchargeGlobal,
			fuelSurcharge: values.fuelSurcharge || 0,
			timeSurchargeGlobal: values.timeSurchargeGlobal,
			timeSurcharge: values.timeSurcharge || 0,
			lightSurchargeGlobal: values.lightSurchargeGlobal,
			lightSurcharge: values.lightSurcharge || 0,
			iceSurchargeGlobal: values.iceSurchargeGlobal,
			iceSurcharge: values.iceSurcharge || 0,
			readyMixTruckRentalServiceGlobal: values.readyMixTruckRentalServiceGlobal,
			readyMixTruckRentalService: values.readyMixTruckRentalService || 0,
			readyMixDriverGlobal: values.readyMixDriverGlobal,
			readyMixDriver: values.readyMixDriver || 0,
			plantStandByGlobal: values.plantStandByGlobal,
			plantStandBy: values.plantStandBy || 0,
			environmentalChargePerLoadGlobal: values.environmentalChargePerLoadGlobal,
			environmentalChargePerLoad: values.environmentalChargePerLoad || 0,
			shippingGlobal: values.shippingGlobal,
			deliveryFee: values.deliveryFee || 0,
			comments: values.comments || undefined,
			slump: values.slump,
			qualityControl: values.qualityControl,
			paymentTerm: values.paymentTerm,
			updatedBy: localStorage.getItem("userId"),
			estimatedTime: values.estimatedTime,
			hotShot: values.hotShot,
			approvedPrice: values.approvedPrice,
			factoredInvoice: values.factoredInvoice,
			isWasteJob: values.isWasteJob,
			project: values.project === undefined ? "undefined" : values.project,
			customerPONumber: values.customerPONumber,
		};

		if (values.isWasteJob) {
			updateValues.commentWaste = values.commentWaste;
		} else {
			updateValues.commentWaste = "";
		}

		if (values.qualityControl) {
			if (values.qcType === "External") {
				updateValues.qcName = values.qcName;
				// updateValues.qcTechnical = values.qcTechnical;
			} else {
				updateValues.qcName = "";
				// updateValues.qcTechnical = "";
			}
			if (values.qcType === "Internal") {
				updateValues.qcInternalType = values.qcInternalType;
			} else {
				updateValues.qcInternalType = undefined;
			}
			updateValues.qcType = values.qcType;
		} else {
			updateValues.qcName = undefined;
			// updateValues.qcTechnical = undefined;
			updateValues.qcInternalType = undefined;
			updateValues.qcType = "Internal";
		}

		if (jobStatusPrev !== updateValues.jobStatus) {
			updateValues.jobStatusHistory = {
				user: localStorage.getItem("userId"),
				jobStatus: updateValues.jobStatus,
			};
		}
		if (psiPrev !== updateValues.psiId) {
			updateValues.psiHistory = {
				user: localStorage.getItem("userId"),
				psi: updateValues.psiId,
			};
		}
		if (unitPricePrev !== updateValues.unitPrice) {
			updateValues.unitPriceHistory = {
				user: localStorage.getItem("userId"),
				unitPrice: updateValues.unitPrice,
				jobStatus: updateValues.jobStatus,
			};
		}
		if (yardsPrev !== updateValues.targetYD3) {
			updateValues.yardsHistory = {
				user: localStorage.getItem("userId"),
				yards: updateValues.targetYD3,
				jobStatus: updateValues.jobStatus,
			};
		}
		if (plantChanged && prevPlant !== updateValues.plant) {
			updateValues.plantChanged = true;
			updateValues.plantChangedHistory = {
				user: localStorage.getItem("userId"),
				prevPlant: prevPlant,
				nextPlant: updateValues.plant,
				prevUnitPrice: prevUnitPrice,
				nextUnitPrice: updateValues.unitPrice,
			};
		}

		let checkInMadeIt = false;

		if (updateValues.jobStatus === "Ready to Load") {
			if (jobStatusPrev !== updateValues.jobStatus) {
				updateValues.readyToBeScheduledDate = dayjs(
					form.getFieldValue("readyToBeScheduledDate"),
				).toDate();
			}

			// if (isOver50) {
			// 	if (
			// 		checkInValues.measurement === false &&
			// 		!(
			// 			localStorage.getItem("email") === "eliud@gmail.com" ||
			// 			localStorage.getItem("email") === "ec@57concrete.com" ||
			// 			localStorage.getItem("email") === "bp@57concrete.com" ||
			// 			localStorage.getItem("email") === "jp@57concrete.com" ||
			// 			localStorage.getItem("email") === "vm@57concrete.com" ||
			// 			localStorage.getItem("email") === "dm@57concrete.com" ||
			// 			localStorage.getItem("email") === "rs@57concrete.com"
			// 		)
			// 	) {
			// 		openNotification(
			// 			"warning",
			// 			"Warning",
			// 			"You must check in to change the status to Ready To Be Scheduled"
			// 		);
			// 		setLoadingComponents(false);
			// 		return;
			// 	} else {
			// 		if (currentMeasurement === false) {
			// 			updateValues.checkInLatitude = checkInLatitude;
			// 			updateValues.checkInLongitude = checkInLongitude;
			// 		}
			// 		updateValues.measurement = checkInValues.measurement;
			// 		updateValues.measurementYards = checkInValues.measurementYards;
			// 		updateValues.readyForTruck = checkInValues.readyForTruck;
			// 		updateValues.readyForTruckComments =
			// 			checkInValues.readyForTruckComments;
			// 		updateValues.lightTowerPositions = checkInValues.lightTowerPositions;
			// 		updateValues.lightTowerPositionsNumberTag =
			// 			checkInValues.lightTowerPositionsNumberTag;
			// 		updateValues.lightTowerPositionsBrand =
			// 			checkInValues.lightTowerPositionsBrand;
			// 		checkInMadeIt = true;
			// 	}
			// }
		} else if (
			updateValues.jobStatus === "ok" ||
			updateValues.jobStatus === "Active"
		) {
			if (isOver30) updateValues.pour = checkInValues.pour;
		}

		if (isOver30) {
			if (
				checkInValues.measurement === false &&
				!(
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "ec@57concrete.com"
				)
			) {
				if (updateValues.jobStatus === "Ready to Load") {
					openNotification(
						"warning",
						"Warning",
						"You must check in to change the status to Ready To Be Scheduled",
					);
					setLoadingComponents(false);
					return;
				}
			} else {
				if (currentMeasurement === false) {
					updateValues.checkInLatitude = checkInLatitude;
					updateValues.checkInLongitude = checkInLongitude;
				}
				updateValues.measurement = checkInValues.measurement;
				updateValues.measurementYards = checkInValues.measurementYards;
				updateValues.readyForTruck = checkInValues.readyForTruck;
				updateValues.readyForTruckComments =
					checkInValues.readyForTruckComments;
				updateValues.lightTowerPositions = checkInValues.lightTowerPositions;
				updateValues.lightTowerPositionsNumberTag =
					checkInValues.lightTowerPositionsNumberTag;
				updateValues.lightTowerPositionsBrand =
					checkInValues.lightTowerPositionsBrand;
				checkInMadeIt = true;
			}
		} else {
			updateValues.measurement = checkInValues.measurement;
			updateValues.measurementYards = checkInValues.measurementYards;
			updateValues.readyForTruck = checkInValues.readyForTruck;
			updateValues.readyForTruckComments = checkInValues.readyForTruckComments;
			updateValues.lightTowerPositions = checkInValues.lightTowerPositions;
			updateValues.lightTowerPositionsNumberTag =
				checkInValues.lightTowerPositionsNumberTag;
			updateValues.lightTowerPositionsBrand =
				checkInValues.lightTowerPositionsBrand;
		}

		// if (pourDate) {
		// 	updateValues.pourDate = dayjs(pourDate).toDate();
		// }

		// updateValues.pourYards = pourYards;

		const url = api + "/job/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.patch(url, updateValues);
			setLoadingComponents(false);

			// setPourYardsPersisted(pourYards);

			if (dateChanged) {
				sendSMSTextToSeller(updateValues.scheduledDate);
			}
			if (addressChanged) {
				sendEmailToTeam();
			}
			// if (isOver50 && checkInMadeIt && currentMeasurement === false) {
			// 	sendEmailToTeamCheckIn();
			// }
			if (fromButton === "save") {
				props.history.push("/dailyappointment");
			}
		} catch (err) {
			openNotification("error", "Error", "Cannot update job details");
			setLoadingComponents(false);
			console.error(err.message);
			return null;
		}
	};

	const sendSMSTextToSeller = async (date) => {
		const url = api + "/sellersms";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		let text = `57Concrete: Date of Job No. ${form.getFieldValue(
			"number",
		)} has been moved to ${date.toLocaleDateString()} - ${date.toLocaleTimeString()}`;
		const body = {
			text: text,
			phone: sellerPhone,
		};

		try {
			await axios.post(url, body);
		} catch (err) {
			console.error(err.message);
		}
	};

	const sendEmailToTeam = async () => {
		const url = api + `/job/address/change/${props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.post(url);
		} catch (err) {
			console.error(err.message);
		}
	};

	const sendEmailToTeamCheckIn = async () => {
		const url = api + `/job/checkin/${props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.post(url);
		} catch (err) {
			console.error(err.message);
		}
	};

	const checkSellerPosition = async (jobLatitude, jobLongitude) => {
		const url = api + `/job/seller/position`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const body = {
				sellerLatitude: checkInLatitude,
				sellerLongitude: checkInLongitude,
				jobLatitude: jobLatitude,
				jobLongitude: jobLongitude,
			};
			const { data } = await axios.post(url, body);
			if (data.success) {
				return data.payload;
			} else {
				return false;
			}
		} catch (err) {
			console.error(err.message);
			return false;
		}
	};

	const onChangeCustomer = (selectedCustomer) => {
		if (selectedCustomer) {
			const values = selectedCustomer.split(",");
			form.setFieldValue("paymentType", values[1] || "");
			form.setFieldValue(
				"paymentTerm",
				values[2] === "undefined" ? "" : values[2],
			);
		}
	};

	const onChangeHotShot = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setMinDateScheduledDate(dayjs());
			form.setFieldValue("scheduledDate", dayjs());
			setDateMax(dayjs());
		} else {
			setMinDateScheduledDate(
				dayjs(new Date(form.getFieldValue("scheduledDate"))).add(36, "hour"),
			);
			form.setFieldValue("scheduledDate", dayjs().add(36, "hour"));
			setDateMax(dayjs(form.getFieldValue("scheduledDate")));
		}
	};

	const CheckInValues = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={24}>
						<Checkbox checked={checkInValues.measurement} disabled>
							Measurement
						</Checkbox>
					</Col>
					<Col span={24} md={12}>
						<Text disabled>Yards</Text>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							value={checkInValues.measurementYards}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Checkbox checked={checkInValues.readyForTruck} disabled>
							Ready For Truck
						</Checkbox>
					</Col>
					<Col span={24} md={12}>
						<Text disabled>Comments</Text>
						<Input
							size="large"
							value={checkInValues.readyForTruckComments}
							disabled
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Checkbox checked={checkInValues.lightTowerPositions} disabled>
							Light Tower Positions
						</Checkbox>
					</Col>
					<Col span={24} md={12}>
						<Text disabled>Number Tag</Text>
						<Input
							size="large"
							value={checkInValues.lightTowerPositionsNumberTag}
							disabled
						/>
					</Col>
					<Col span={24} md={12}>
						<Text disabled>Brand</Text>
						<Input
							size="large"
							disabled
							value={checkInValues.lightTowerPositionsBrand}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Checkbox checked={checkInValues.pour} disabled>
							Pour
						</Checkbox>
					</Col>
				</Row>
			</div>
		);
	};

	const onChangePlant = async (selectedPlant) => {
		form.setFieldsValue({
			psiPrice: undefined,
			unitPrice: undefined,
			taxPrice: undefined,
			psiName: undefined,
			psi: undefined,
			psiId: undefined,
		});
		await getPsi(franchise, selectedPlant);
		setPlantChanged(true);
	};

	const onChangeQC = (e) => {
		setQC(e.target.checked);
	};
	const onChangeWaste = (e) => {
		setIsWasteJob(e.target.checked);
	};

	const onChangeQCType = (v) => {
		setQCType(v);
	};

	const onFinish = async () => {
		setLoadingComponents(true);
		updateJob("save");
	};

	const allowedEmailsScheduled = [
		"rs@57concrete.com",
		"fr@57concrete.com",
		"jp@57concrete.com",
		"ji@57concrete.com",
		"eliud@gmail.com",
	];

	const currentEmail = localStorage.getItem("email");

	const canEditScheduled =
		jobStatusCurrent !== "Scheduled" ||
		allowedEmailsScheduled.includes(currentEmail);

	const RenderModalUnitPrice = () => {
		return (
			<Modal
				title="Unit Price has changed!"
				centered
				destroyOnHidden
				open={openModalUnitPrice}
				onCancel={() => setOpenModalUnitPrice(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
			>
				<div style={{ whiteSpace: "pre-line" }}>{messageUnitPrice.current}</div>
			</Modal>
		);
	};

	// const handleTogglePourYards = () => {
	// 	if (!canEditPourYards()) {
	// 		openNotification(
	// 			"warning",
	// 			"Warning",
	// 			"You are not allowed to modify pour yards at this time",
	// 		);
	// 		return;
	// 	}
	// 	setPourYards((prev) => !prev);
	// };

	const canEditScheduledInputs =
		!onScheduled ||
		AUTHORIZED_EMAILS_SCHEDULED.includes(localStorage.getItem("email"));

	const RenderForm = () => (
		<Form
			form={form}
			layout="vertical"
			initialValues={initialValues}
			onFinish={onFinish}
		>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item label="Job ID" name="number">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={12}>
					<Form.Item
						label="Customer"
						name="customer"
						rules={[
							{
								required: true,
								message: "Please select a customer",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a customer"
							loading={loadingComponents || loadingCustomer}
							options={customers}
							onChange={onChangeCustomer}
							showSearch
							disabled={
								loadingComponents ||
								loadingCustomer ||
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com"
								)
							}
							optionFilterProp="children"
							filterOption={filterOption}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={6} lg={5} xl={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						style={{ width: "100%" }}
						icon={<PlusOutlined />}
						loading={loadingComponents}
						disabled={
							loadingComponents ||
							!(
								localStorage.getItem("email") === "eliud@gmail.com" ||
								localStorage.getItem("email") === "ec@57concrete.com" ||
								localStorage.getItem("email") === "pc@57concrete.com" ||
								localStorage.getItem("email") === "jc@57concrete.com" ||
								localStorage.getItem("email") === "gg@57xgroup.com"
							)
						}
						onClick={handleNewCustomerOpen}
					>
						New Customer
					</Button>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Seller"
						name="seller"
						rules={[
							{
								required: true,
								message: "Please select a seller",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select seller"
							options={sellers}
							disabled={
								loadingComponents ||
								loadingSeller ||
								!(
									localStorage.getItem("role") === "Admin" ||
									localStorage.getItem("email") === "vc@57concrete.com" ||
									localStorage.getItem("email") === "rl@57concrete.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "jh@57concrete.com" ||
									localStorage.getItem("email") === "eliud@gmail.com"
								) ||
								franchise === "Valley Wide"
							}
							loading={loadingComponents || loadingSeller}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Job Status"
						name="jobStatus"
						rules={[
							{
								required: true,
								message: "Please select a status",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select job status"
							options={jobStatusOptions}
							disabled={
								loadingComponents ||
								!(
									localStorage.getItem("role") === "Admin" ||
									localStorage.getItem("email") === "rl@57concrete.com" ||
									localStorage.getItem("email") === "vc@57concrete.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "jh@57concrete.com" ||
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "jac@57concrete.com" ||
									localStorage.getItem("email") === "ds@57concrete.com" ||
									localStorage.getItem("email") === "ep@57concrete.com" ||
									localStorage.getItem("email") === "ev@57concrete.com" ||
									localStorage.getItem("email") === "jbr@57concrete.com"
								) ||
								!canEditScheduled
							}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							onChange={onChangeJobStatus}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Job Name" name="name">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item label="Job Description" name="jobDescription">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item label="Project (optional)" name="project">
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a project"
							options={projectList}
							disabled={loadingComponents}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							allowClear
						/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item label="Customer PO Number" name="customerPONumber">
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Job Type"
						name="jobType"
						rules={[
							{
								required: true,
								message: "Please select job type",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select job type"
							options={jobTypeOptions}
							disabled={loadingComponents}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Job Pour"
						name="jobPoor"
						rules={[
							{
								required: true,
								message: "Please select job pour",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select job pour"
							options={jobPourOptions}
							disabled={loadingComponents}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Plant"
						name="plant"
						rules={[
							{
								required: true,
								message: "Please select a plant",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a plant"
							options={plants}
							disabled={loadingComponents || loadingPlant}
							loading={loadingComponents || loadingPlant}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							onChange={onChangePlant}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Psi"
						name="psi"
						rules={[
							{
								required: true,
								message: "Please select a psi",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a psi"
							options={psi}
							disabled={loadingComponents || loadingPsi}
							loading={loadingComponents || loadingPsi}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							onChange={onChangePsi}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Title level={3}>Ship to Address</Title>
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						icon={<SearchOutlined />}
						style={{ width: "100%" }}
						onClick={handleSearchAddressOpen}
						disabled={loadingComponents || !canEditScheduledInputs}
						loading={loadingComponents}
					>
						Search Address
					</Button>
				</Col>
				<Col span={24} md={8}>
					<Form.Item
						label="Ship Address"
						name="shipAddress"
						rules={[
							{
								required: true,
								message: "Fill ship address",
							},
						]}
					>
						<Input size="large" disabled />
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item
						label="Customer Ship Address"
						name="customerShipAddress"
						rules={[
							{
								required: true,
								message: "Fill customer ship address",
							},
						]}
					>
						<Input
							size="large"
							disabled={loadingComponents || !canEditScheduledInputs}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={4}>
					<Form.Item
						label="Ship City"
						name="shipCity"
						rules={[
							{
								required: true,
								message: "Please select a city",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a city"
							options={cityList}
							disabled={loadingComponents || !canEditScheduledInputs}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							onChange={onChangeCity}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item label="Time to Destination" name="destinationTime">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item label="Distance" name="distance">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={12}>
					<Form.Item
						label="Foreman"
						name="foremanItem"
						rules={[
							{
								required: true,
								message: "Please select a foreman",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select foreman"
							options={foremans}
							disabled={loadingComponents}
							loading={loadingForeman}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							onChange={onChangeForeman}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={6} lg={5} xl={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						icon={<PlusOutlined />}
						style={{ width: "100%" }}
						onClick={handleNewForemanOpen}
						disabled={loadingComponents}
						loading={loadingComponents}
					>
						New Foreman
					</Button>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Foreman Phone" name="foremanPhone">
						<Input size="large" addonBefore={prefixSelector} disabled />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Supervisor Name" name="supervisorName">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="Supervisor Phone"
						name="supervisorPhone"
						rules={[
							{
								len: 10,
								max: 10,
								message: "Phone number must have 10 numbers",
							},
						]}
					>
						<Input
							size="large"
							addonBefore={prefixSelector}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Project Manager Name" name="projectManager">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="Project Manager Phone"
						name="pmPhone"
						rules={[
							{
								len: 10,
								max: 10,
								message: "Phone number must have 10 numbers",
							},
						]}
					>
						<Input
							size="large"
							addonBefore={prefixSelector}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="AP Contact Name" name="apContact">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="AP Contact Phone"
						name="apPhone"
						rules={[
							{
								len: 10,
								max: 10,
								message: "Phone number must have 10 numbers",
							},
						]}
					>
						<Input
							size="large"
							addonBefore={prefixSelector}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Customer 1 Name" name="customer1">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="Customer 1 Phone"
						name="customer1Phone"
						rules={[
							{
								len: 10,
								max: 10,
								message: "Phone number must have 10 numbers",
							},
						]}
					>
						<Input
							size="large"
							addonBefore={prefixSelector}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item label="Customer 2 Name" name="customer2">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="Customer 2 Phone"
						name="customer2Phone"
						rules={[
							{
								len: 10,
								max: 10,
								message: "Phone number must have 10 numbers",
							},
						]}
					>
						<Input
							size="large"
							addonBefore={prefixSelector}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={8}>
					<Form.Item name="taxExemptJob" label="Tax Exempt Job">
						<Radio.Group
							size="large"
							disabled={loadingComponents}
							buttonStyle="solid"
						>
							<Radio.Button value={true}>Yes</Radio.Button>
							<Radio.Button value={false}>No</Radio.Button>
						</Radio.Group>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Payment Type"
						name="paymentType"
						// rules={[
						// 	{
						// 		required: true,
						// 		message: "Please select a payment type",
						// 	},
						// ]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select payment type"
							options={paymentTypeOptions}
							disabled
							// disabled={
							// 	loadingComponents || !localStorage.getItem("role") === "Finance"
							// }
							optionFilterProp="children"
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Payment Term"
						name="paymentTerm"
						// rules={[
						// 	{
						// 		required: true,
						// 		message: "Please select a payment term",
						// 	},
						// ]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select payment type"
							options={paymentTypeOptions}
							disabled
							// disabled={
							// 	loadingComponents || !localStorage.getItem("role") === "Finance"
							// }
							optionFilterProp="children"
						/>
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Row gutter={16}>
				<Col span={6}>
					<Form.Item
						label="Target YD3"
						name="targetYD3"
						rules={[
							{
								required: true,
								message: "Please fill target",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents || !canEditScheduledInputs}
						/>
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label="Balance" name="balance">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={true}
						/>
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label="Job Duration" name="jobDuration">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item
						label="Delivery Rate (CY/HR)"
						name="deliveryRate"
						rules={[
							{
								required: true,
								message: "Please fill delivery rate",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={8}>
					<Form.Item
						name="scheduledDate"
						label="Job date/time"
						rules={[
							{
								required: true,
								message: "Scheduled Date is required",
							},
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							size="large"
							showTime={{ format: "HH:mm" }}
							format="MM/DD/YYYY HH:mm A"
							allowClear={false}
							onChange={onChangeDate}
							disabled={loadingComponents || disabledDate || !canEditScheduled}
							minDate={minDateScheduledDate}
						/>
					</Form.Item>
				</Col>
				{scheduledDateChanged && (
					<Col span={24} md={8}>
						<Form.Item
							name="scheduledDateComment"
							label="Comment"
							rules={[
								{
									required: true,
									message: "Scheduled Date Change is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				)}
				<Col span={24} md={8}>
					<Form.Item
						name="inspectionTimeStamp"
						label="Inspection date/time"
						rules={[
							{
								required: true,
								message: "Inspection Time Stamp is required",
							},
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							size="large"
							showTime={{ format: "HH:mm" }}
							format="MM/DD/YYYY HH:mm A"
							allowClear={false}
							maxDate={dateMax}
							disabledTime={disabledDateTime}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				{(localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "mv@57concrete.com" ||
					localStorage.getItem("email") === "al@57concrete.com" ||
					localStorage.getItem("email") === "jp@57concrete.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "bp@57concrete.com") && (
					<Col span={24} md={8}>
						<Form.Item name="estimatedTime" label="Estimated Time (minutes)">
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled={loadingComponents}
							/>
						</Form.Item>
					</Col>
				)}
			</Row>
			<Row gutter={16}>
				<Col span={24} md={8}>
					<Form.Item label="Hot Shot" name="hotShot" valuePropName="checked">
						<Checkbox onChange={onChangeHotShot}>Is Hot Shot?</Checkbox>
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item label="Fiber Quantity" name="fiberQuantity">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item label="Paid" name="paid" valuePropName="checked">
						<Checkbox>Is Paid?</Checkbox>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Unit Price"
						name="unitPrice"
						rules={[
							{
								required: true,
								message: "Unit Price is required",
							},
							{
								validator: (_, value) => {
									if (value < minPrice) {
										return Promise.reject(
											new Error(`Unit Price must be greater than ${minPrice}`),
										);
									}
									return Promise.resolve();
								},
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={
								loadingComponents ||
								localStorage.getItem("email") === "eliud@gmail.com" ||
								localStorage.getItem("email") === "ec@57concrete.com" ||
								localStorage.getItem("email") === "pc@57concrete.com" ||
								localStorage.getItem("email") === "jc@57concrete.com" ||
								localStorage.getItem("email") === "gg@57xgroup.com"
									? false
									: approvedPrice
							}
							onChange={onChangeUnitPrice}
							precision={3}
						/>
					</Form.Item>
				</Col>

				<Col span={24} md={12}>
					<Form.Item
						label="Price with Tax"
						name="taxPrice"
						rules={[
							{
								required: true,
								message: "Price with Tax is required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled
							precision={3}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={4}>
					<Form.Item name="fuelSurchargeGlobal" valuePropName="checked">
						<Checkbox disabled={loadingComponents}>Apply To Global</Checkbox>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Fuel Surcharge" name="fuelSurcharge">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>

				<Col span={4}>
					<Form.Item name="shippingGlobal" valuePropName="checked">
						<Checkbox disabled={loadingComponents}>Apply To Global</Checkbox>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Shipping Fee" name="deliveryFee">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>

				{franchise !== "Castle" && (
					<>
						<Col span={4}>
							<Form.Item name="timeSurchargeGlobal" valuePropName="checked">
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item label="Time Surcharge" name="timeSurcharge">
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name="lightSurchargeGlobal" valuePropName="checked">
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item label="Light Vehicle Surcharge" name="lightSurcharge">
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name="iceSurchargeGlobal" valuePropName="checked">
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item label="Ice Surcharge" name="iceSurcharge">
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name="plantStandByGlobal" valuePropName="checked">
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item label="Plant Stand-By" name="plantStandBy">
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								name="environmentalChargePerLoadGlobal"
								valuePropName="checked"
							>
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label="Environmental Charge Per Load"
								name="environmentalChargePerLoad"
							>
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
					</>
				)}

				{franchise === "Castle" && (
					<>
						<Col span={4}>
							<Form.Item
								name="readyMixTruckRentalServiceGlobal"
								valuePropName="checked"
							>
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label="Ready Mix Truck Rental Service"
								name="readyMixTruckRentalService"
							>
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name="readyMixDriverGlobal" valuePropName="checked">
								<Checkbox disabled={loadingComponents}>
									Apply To Global
								</Checkbox>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item label="Ready Mix Driver" name="readyMixDriver">
								<InputNumber
									size="large"
									style={{ width: "100%" }}
									formatter={(value) =>
										`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
									}
									parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
									disabled={loadingComponents}
								/>
							</Form.Item>
						</Col>
					</>
				)}
			</Row>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item label="Comments" name="comments">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Slump"
						name="slump"
						rules={[
							{
								required: true,
								message: "Please select a slump",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select slump"
							options={slumpOptions}
							optionFilterProp="children"
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				<Col span={qc ? 2 : 12}>
					<Form.Item
						label="Quality Control"
						name="qualityControl"
						valuePropName="checked"
					>
						<Checkbox disabled={loadingComponents} onChange={onChangeQC}>
							QC Inspection
						</Checkbox>
					</Form.Item>
				</Col>
				{qc && (
					<Col span={5}>
						<Form.Item
							label="QC Type"
							name="qcType"
							rules={[
								{
									required: true,
									message: "Please select a type",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select a type"
								loading={loadingComponents || loadingCustomer}
								options={qcTypes}
								onChange={onChangeQCType}
								showSearch
								disabled={loadingComponents || loadingCustomer}
								optionFilterProp="children"
								filterOption={filterOption}
								defaultValue={"Internal"}
							/>
						</Form.Item>
					</Col>
				)}
				{qc && qcType === "External" && (
					<Col span={5}>
						<Form.Item
							label="QC Name"
							name="qcName"
							rules={[
								{
									required: true,
									message: "Fill QC Name",
								},
							]}
						>
							<Input size="large" disabled={loadingComponents} />
						</Form.Item>
					</Col>
				)}
				{/* {qc && qcType === "External" && (
					<Col span={5}>
						<Form.Item
							label="QC Technician"
							name="qcTechnical"
							rules={[
								{
									required: true,
									message: "Fill QC Technician",
								},
							]}
						>
							<Input size="large" disabled={loadingComponents} />
						</Form.Item>
					</Col>
				)} */}
				{qc && qcType === "Internal" && (
					<Col span={5}>
						<Form.Item
							label="QC Internal Type"
							name="qcInternalType"
							rules={[
								{
									required: true,
									message: "Fill QC Internal Type",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select a internal type"
								loading={loadingComponents || loadingCustomer}
								options={qcInternalTypes}
								showSearch
								disabled={loadingComponents || loadingCustomer}
								optionFilterProp="children"
								filterOption={filterOption}
							/>
						</Form.Item>
					</Col>
				)}
				<Col span={8}>
					<Form.Item
						label="Approved Price"
						name="approvedPrice"
						valuePropName="checked"
					>
						<Checkbox
							disabled={
								loadingComponents ||
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com"
								)
							}
							onChange={(e) => setApprovedPrice(e.target.checked)}
						>
							EC
						</Checkbox>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Factored Invoice"
						name="factoredInvoice"
						valuePropName="checked"
					>
						<Checkbox
							disabled={
								loadingComponents ||
								!(
									localStorage.getItem("email") === "eliud@gmail.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com"
								)
							}
						>
							Yes / No
						</Checkbox>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={8}>
					<Form.Item label="Waste" name="isWasteJob" valuePropName="checked">
						<Checkbox disabled={loadingComponents} onChange={onChangeWaste}>
							Is Waste Job?
						</Checkbox>
					</Form.Item>
				</Col>
				{isWasteJob && (
					<Col span={8}>
						<Form.Item
							label="Reason for Waste"
							name="commentWaste"
							rules={[
								{
									required: true,
									message: "Fill Comment",
								},
							]}
						>
							<Input.TextArea size="large" disabled={loadingComponents} />
						</Form.Item>
					</Col>
				)}
			</Row>
			<Divider />
			<Title level={3}>Job Status History</Title>
			<CustomTable
				columns={columnsJobStatus}
				data={jobStatusHistory}
				isScroll={false}
			/>
			<Divider />
			<Title level={3}>PSI History</Title>
			<CustomTable columns={columnsPsi} data={psiHistory} isScroll={false} />
			<Divider />
			<Title level={3}>Scheduled Date History</Title>
			<CustomTable
				columns={columnsScheduledDate}
				data={scheduledDateHistory}
				isScroll={false}
			/>
			<Divider />
			<Title level={3}>Plant Changed History</Title>
			<CustomTable
				columns={columnsPlantChanged}
				data={plantChangedHistory}
				isScroll={false}
			/>
			<Divider />
			<Title level={3}>Unit Price History</Title>
			<CustomTable
				columns={columnsUnitPrice}
				data={unitPriceHistory}
				isScroll={false}
			/>
			<Divider />
			<Title level={3}>Yards History</Title>
			<CustomTable
				columns={columnsYards}
				data={yardsHistory}
				isScroll={false}
			/>
			<Divider />
			<Title level={3}>Check In</Title>
			<CheckInValues />
			<Divider />
			<Row gutter={[16, 8]}>
				<Col>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
					>
						Save
					</Button>
				</Col>
				{(localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "eliud@gmail.com") && (
					<Col>
						<Popconfirm
							title="Delete the job"
							description="Are you sure to delete this job?"
							okText="Yes"
							cancelText="No"
							onConfirm={deleteJob}
						>
							<Button
								type="primary"
								danger
								htmlType="button"
								size="large"
								loading={loadingComponents}
								disabled={loadingComponents}
							>
								Delete
							</Button>
						</Popconfirm>
					</Col>
				)}
				{(localStorage.getItem("role") === "Admin" ||
					localStorage.getItem("role") === "Seller" ||
					localStorage.getItem("email") === "eliud@gmail.com") && (
					<Col>
						<Button
							type="primary"
							style={{ backgroundColor: "gray" }}
							htmlType="button"
							size="large"
							loading={loadingComponents}
							disabled={loadingComponents}
							onClick={jobPhotos}
						>
							Photos
						</Button>
					</Col>
				)}
				{(localStorage.getItem("role") === "Admin" ||
					localStorage.getItem("role") === "Finance") && (
					<Col>
						<Button
							type="primary"
							style={{ backgroundColor: "purple" }}
							htmlType="button"
							size="large"
							loading={loadingComponents}
							disabled={loadingComponents}
							onClick={showHistory}
						>
							Change Log
						</Button>
					</Col>
				)}
				<Col>
					<Button
						type="primary"
						style={{ backgroundColor: "green" }}
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
						onClick={showQuote}
					>
						Quote PDF
					</Button>
				</Col>
				{jobStatusCurrent === "Operations done (AR)" && (
					<Col>
						<Button
							type="primary"
							style={{ backgroundColor: "blue" }}
							htmlType="button"
							size="large"
							loading={loadingComponents}
							disabled={loadingComponents}
							onClick={showInvoice}
						>
							Invoice
						</Button>
					</Col>
				)}
				{loads.length !== 0 && (
					<Col>
						<Button
							type="primary"
							htmlType="button"
							size="large"
							loading={loadingComponents}
							disabled={loadingComponents}
							onClick={showEtickets}
						>
							Etickets
						</Button>
					</Col>
				)}
				{jobStatusCurrent === "Operations done (AR)" && (
					<Col>
						<Button
							type="primary"
							htmlType="button"
							size="large"
							loading={loadingComponents}
							disabled={loadingComponents}
							onClick={showInvoiceEtickets}
							style={{ backgroundColor: "black" }}
						>
							Invoice + Etickets
						</Button>
					</Col>
				)}
				<Col>
					<Button
						type="default"
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
						onClick={handleShowLoadsOpen}
					>
						Loads
					</Button>
				</Col>
				{/* {isOver30 && ( */}
				<Col>
					<Button
						type="primary"
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
						onClick={handleCheckInOpen}
					>
						Job Check In
					</Button>
				</Col>
				{/* <Col>
					<Button
						type="primary"
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents || !canEditPourYards()}
						onClick={handleTogglePourYards}
						style={{ backgroundColor: pourYards ? "#208928" : "#6610a0" }}
					>
						{pourYards ? "Pour Confirmed ✓" : "Confirm Pour"}
					</Button>
				</Col> */}
				{/* )} */}
				{/* <Col>
					<Button
						type="primary"
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
						onClick={handleProjectExemptOpen}
					>
						Project Tax Exempt
					</Button>
				</Col>
				<Col>
					<Button
						type="primary"
						htmlType="button"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
						onClick={handleProjectBondOpen}
					>
						Project Bond
					</Button>
				</Col> */}
			</Row>
		</Form>
	);

	return (
		<Layout title="Job" description="Edit Job">
			<Flex vertical gap={"large"}>
				{contextHolder}
				{loading ? <CustomSpinner /> : <RenderForm />}
				<RenderNewCustomerModal />
				<RenderSearchAddressModal />
				<RenderNewForemanModal />
				<RenderShowLoadsModal />
				<RenderCheckInModal />
				<RenderShowProjectExemptModal />
				<RenderShowProjectBondModal />
				<RenderModalUnitPrice />
			</Flex>
		</Layout>
	);
};

export default Job2;
